<onyx-icon [name]="icon()" [size]="16"></onyx-icon>

@if (status() !== OrderStageStatus.TO_DO) {
  <div class="dot-container">
    @switch (status()) {
      @case (OrderStageStatus.IN_PROGRESS) {
        <onyx-dot color="blue" [size]="10" [pulse]="true"></onyx-dot>
      }

      @case (OrderStageStatus.COMPLETED) {
        <onyx-dot color="white" [size]="12" [pulse]="false">
          <onyx-icon
            class="f-success"
            name="check-circle-filled"
            [size]="12"
          ></onyx-icon>
        </onyx-dot>
      }

      @case (OrderStageStatus.SKIPPED) {
        <onyx-dot color="white" [size]="12" [pulse]="false">
          <onyx-icon
            class="f-danger"
            name="clear-filled"
            [size]="12"
          ></onyx-icon>
        </onyx-dot>
      }
    }
  </div>
}
